// CRUD
export const TRIAL_CREATE = "TRIAL_CREATE"
export const TRIAL_CREATE_ASYNC = "TRIAL_CREATE_ASYNC"